import { AbstractControl, ValidationErrors } from "@angular/forms";




export function cnpjValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value?.replace(/\D/g, '');
    if (!value || value.length !== 14 || /^(\d)\1+$/.test(value)) return { cnpjInvalid: true };
  
    const calc = (x: number[]) =>
      x
        .map((n, i) => +value[i] * n)
        .reduce((soma, el) => soma + el, 0);
  
    const d1 = calc([5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
    let dig1 = d1 % 11;
    dig1 = dig1 < 2 ? 0 : 11 - dig1;
  
    const d2 = calc([6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
    let dig2 = d2 % 11;
    dig2 = dig2 < 2 ? 0 : 11 - dig2;
  
    if (+value[12] !== dig1 || +value[13] !== dig2) return { cnpjInvalid: true };
  
    return null;
  }